import { queryOptions } from '@tanstack/react-query';
import { getApartmentContent } from '@/api/generated/sdk.gen';
import type { ApartmentContent } from '@/api/generated/types.gen';

export type { ApartmentContent };

export const apartmentContentQuery = (id: string) =>
  queryOptions({
    queryKey: ['apartments', id, 'content'],
    queryFn: async ({ signal }) => {
      const res = await getApartmentContent({ throwOnError: true, signal, path: { id } });
      return res.data;
    },
    staleTime: 30_000,
  });
